export default {
  errorBrandCode: null,
  errorName: null,
  errorStartDate: null,
  errorEndDate: null,
  errorSurveyUrl: null,
  errorDetailTh: null,
  errorDetailEn: null,
  errorSurveyResultPath: null,
  errorExcelSurveyResultPath: null,
};
